export const AIRCRAFT_API = '/api/drones';

export const FETCH_ALL_PAGE_SIZE = 100;
